<template lang="pug">
  .PostContentAuthor.post-content-author
    .post-content-author__wrapper
      router-link.post-content-author__link(
        :to="data.author.route"
        :class="{'is--icon': !data.author.image}"
        :aria-label="`Click on author ${data.authorFullName}`"
      )
        BaseImage.post-content-author__image(
          v-if="data.author.image"
          :src="data.author.image",
          :alt="data.author.first_name",
        )
        // Fix to work v-if/v-else with FA
        div(v-else)
          SolidUserAltIcon.svg-icon.user-alt.post-content-author__icon
      .post-content-author__name
        router-link.post-content-author__name-link(
          :to="data.author.route"
          :class="{'is--icon': !data.author.image}"
        )
          .is-h5__title {{ data.authorFullName }}
        p.mb-0 {{ data.author.title }}
    p.small-text.post-content-author__content(v-if="data.author.short_bio") {{ data.author.short_bio }}
</template>

<script>
import { BasePostClass } from 'Classes';
import SolidUserAltIcon from 'images/svg-icons/solid-user-alt.svg?component';

export default {
  name: 'PostContentAuthor',
  components: {
    SolidUserAltIcon,
  },
  props: {
    data: {
      type: BasePostClass,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.post-content-author
  width: 100%
  @media screen and (max-width: 767px)
    max-width: 100%
    margin-right: 0
  &__content
    margin-top: 15px
    margin-bottom: 0
  &__wrapper
    display: flex
    flex-direction: row
    align-items: center
  &__link
    display: flex
    justify-content: center
    align-items: center
    width: 68px
    height: 68px
    border: 1px solid $support_lightgray
    background: $alabaster
    border-radius: 100%
    margin-right: 15px
  &__image
    margin: 0
    border-radius: 100%
    width: 66px
    height: 66px
  &__icon
    width: 40px
    height: 46px
    fill: $support_lightgray
  &__name
    display: flex
    flex-direction: column
    justify-content: center
  &__name-link
    display: flex !important
    margin-bottom: 0
</style>
